export type OfferTemplateId =
  | "classic"
  | "friendly"
  | "minimal"
  | "warm-home"
  | "noir-premium"
  | "bordeaux"
  | "slate-corporate"
  | "emerald"
  | "workshop-modern";

export interface OfferTemplateDefinition {
  id: OfferTemplateId;
  name: string;
  description: string;
  /** Główna rodzina fontów (nagłówek/logo) — ładowana w index.html */
  fontFamily: string;
  /** Identyfikator wariantu layoutu — używany jako data-template w CSS */
  layoutVariant: OfferTemplateId;
  colors: {
    headerBg: string;
    headerText: string;
    accentColor: string;
    bodyBg: string;
    totalBg: string;
    totalText: string;
    borderColor: string;
    metaText: string;
  };
}

export const OFFER_TEMPLATES: OfferTemplateDefinition[] = [
  {
    id: "classic",
    name: "Solidna Klasyka",
    description: "Klasyczny, notarialny. Serif w logo, monospacowe liczby.",
    fontFamily: "Playfair Display",
    layoutVariant: "classic",
    colors: {
      headerBg: "#ffffff",
      headerText: "#1a1816",
      accentColor: "#e76f51",
      bodyBg: "#ffffff",
      totalBg: "#1a1816",
      totalText: "#ffffff",
      borderColor: "#ddd8d0",
      metaText: "#7a6e65",
    },
  },
  {
    id: "friendly",
    name: "Przyjazny Fachowiec",
    description: "Granatowy + żółty. Ciepły, ludzki, zaufany.",
    fontFamily: "Nunito",
    layoutVariant: "friendly",
    colors: {
      headerBg: "#1e3a5f",
      headerText: "#ffffff",
      accentColor: "#f5c842",
      bodyBg: "#ffffff",
      totalBg: "#f0f6ff",
      totalText: "#1e3a5f",
      borderColor: "#d8e4f0",
      metaText: "#5a8abf",
    },
  },
  {
    id: "minimal",
    name: "Budowlany Minimal",
    description: "Inżynierski, techniczny. IBM Plex, zero ozdobników.",
    fontFamily: "IBM Plex Sans",
    layoutVariant: "minimal",
    colors: {
      headerBg: "#ffffff",
      headerText: "#1a1816",
      accentColor: "#e76f51",
      bodyBg: "#ffffff",
      totalBg: "#ffffff",
      totalText: "#1a1816",
      borderColor: "#cccccc",
      metaText: "#888888",
    },
  },
  {
    id: "warm-home",
    name: "Ciepły Dom",
    description: "Kremowa biel, terakota, oliwkowy akcent kategorii.",
    fontFamily: "Space Grotesk",
    layoutVariant: "warm-home",
    colors: {
      headerBg: "#fdf8f3",
      headerText: "#2a1e14",
      accentColor: "#c0673a",
      bodyBg: "#fdf8f3",
      totalBg: "#fff8f0",
      totalText: "#2a1e14",
      borderColor: "#e8ddd4",
      metaText: "#9a8878",
    },
  },
  {
    id: "noir-premium",
    name: "Noir Premium",
    description: "Split nagłówek czarny/biały. Złoty akcent. Syne.",
    fontFamily: "Syne",
    layoutVariant: "noir-premium",
    colors: {
      headerBg: "#111111",
      headerText: "#ffffff",
      accentColor: "#c9a84c",
      bodyBg: "#ffffff",
      totalBg: "#111111",
      totalText: "#ffffff",
      borderColor: "#e8e4e0",
      metaText: "#888888",
    },
  },
  {
    id: "bordeaux",
    name: "Bordeaux",
    description: "Wiśniowy akcent, Cormorant Garamond serif.",
    fontFamily: "Cormorant Garamond",
    layoutVariant: "bordeaux",
    colors: {
      headerBg: "#fdfaf7",
      headerText: "#1a1210",
      accentColor: "#6b1f2a",
      bodyBg: "#fdfaf7",
      totalBg: "#fdfaf7",
      totalText: "#1a1210",
      borderColor: "#e0d8d0",
      metaText: "#9a8878",
    },
  },
  {
    id: "slate-corporate",
    name: "Slate Corporate",
    description: "Granatowy + złoto. Korporacyjny, precyzyjny.",
    fontFamily: "Plus Jakarta Sans",
    layoutVariant: "slate-corporate",
    colors: {
      headerBg: "#2d4a6e",
      headerText: "#ffffff",
      accentColor: "#c9a84c",
      bodyBg: "#ffffff",
      totalBg: "#edf3fa",
      totalText: "#1a2a40",
      borderColor: "#c8d4e0",
      metaText: "#6a8aaa",
    },
  },
  {
    id: "emerald",
    name: "Emerald",
    description: "Zielony pasek przez cały dokument. Libre Baskerville.",
    fontFamily: "Libre Baskerville",
    layoutVariant: "emerald",
    colors: {
      headerBg: "#ffffff",
      headerText: "#1a1816",
      accentColor: "#1a4a30",
      bodyBg: "#ffffff",
      totalBg: "#f4faf2",
      totalText: "#1a1816",
      borderColor: "#c8d8c0",
      metaText: "#7a8a78",
    },
  },
  {
    id: "workshop-modern",
    name: "Workshop Modern",
    description: "Domyślny styl Builder — ciepły antracyt, coral.",
    fontFamily: "DM Sans",
    layoutVariant: "workshop-modern",
    colors: {
      headerBg: "#1c1a18",
      headerText: "#ede7dc",
      accentColor: "#e76f51",
      bodyBg: "#ffffff",
      totalBg: "#1c1a18",
      totalText: "#ede7dc",
      borderColor: "#e0dbd4",
      metaText: "#a09488",
    },
  },
];

export const DEFAULT_TEMPLATE_ID: OfferTemplateId = "classic";
